
import { CLabel } from '@tokyojob/frontend-components'
import Vue, { PropType } from 'vue'
import { IVacancyDetailCard } from './interface/i-vacancy-detail-card'

export default Vue.extend({
  components: {
    CLabel,
  },
  props: {
    properties: {
      type: Object as PropType<IVacancyDetailCard>,
      required: true,
    },
  },
})
